// extracted by mini-css-extract-plugin
export default {"img":"Carousel_img__ERKwH","Carousel":"Carousel_Carousel__9rJig"};